import { render, staticRenderFns } from "./CallOutText.vue?vue&type=template&id=aef7bb94&scoped=true"
import script from "./CallOutText.vue?vue&type=script&lang=js"
export * from "./CallOutText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef7bb94",
  null
  
)

export default component.exports